import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { TextInput, Button } from 'react-orange-ui';

import Captcha from '../../Captcha/Captcha';
import TitleWithCard from '../../Title/TitleWithCard';

import TagService from '../../../services/TagService';
import WordingService from '../../../services/WordingService';

class LoginView extends Component {
  state = {
    value: '',
  };

  /**
   * Generate the captcha and set the login when exists on mount
   */
  componentDidMount() {
    const { generateCaptcha, login } = this.props;

    if (login) {
      this.setState({ value: login });
    }
    generateCaptcha();
  }

  /**
   * Create a string of selected captcha images values
   * @param selectedImages
   * @return {string}
   */
  createQueryCaptcha = (selectedImages) => {
    if (selectedImages && selectedImages.length) {
      const values = selectedImages.map(image => image.value);
      return `${values.join('-')}-`;
    }
    return '-';
  };

  /**
   * Set value state and clear error when exist on input change
   * @param value
   */
  handleChange = (value) => {
    const { clearInputError, loginError } = this.props;

    this.setState({
      value: value.trim(),
    });
    if (value && !loginError.valid) {
      clearInputError({ field: 'login' });
    }
  };

  /**
   * Check login credentials on input blur, set empty error when no value is filled
   */
  handleBlur = () => {
    const { checkCredentials, setInputError } = this.props;
    const { value } = this.state;

    if (!value) {
      setInputError({ field: 'login', error: 'empty' });
    } else {
      checkCredentials('login', value);
    }
  };

  /**
   * Create an identity object
   */
  handleClick = (e) => {
    e.preventDefault();

    const { createIdentities, captcha } = this.props;
    const { value } = this.state;

    createIdentities({
      login: value,
      captcha: this.createQueryCaptcha(captcha.selectedImages),
    });
  };

  render() {
    const { value } = this.state;
    const { captcha, isLoading, loginError } = this.props;

    return (
      <div id="ident-form">
        <Row>
          <Col xs={12} sm={12} md={9} lg={6} xl={6}>
            <TextInput
              id="login-input"
              value={value}
              valid={loginError.valid}
              errorMessage={loginError.errorMessage}
              placeholder={WordingService.getWording('placeholder', 'emailOrMobile')}
              maxLength={254}
              onBlur={this.handleBlur}
              onChange={this.handleChange}
            >
              <TitleWithCard
                idLabel="loginLabel"
                idIcon="loginHelp"
                title={WordingService.getWording('caption', 'yourAccount')}
                hint={WordingService.getWording('hint', 'fillLogin')}
                onIconClick={() => TagService.sendAction('helpLogin')}
              />
            </TextInput>
          </Col>
        </Row>
        { captcha.isReady && <Captcha errorMessage={captcha.status.errorMessage} indications={captcha.indications} images={captcha.images} /> }
        <br />
        <Row>
          <Col sm={12}>
            <Button id="btnSubmit" type="fill" disabled={isLoading} onClick={this.handleClick} onMouseDown={this.handleClick}>
              {WordingService.getWording('button', 'continue')}
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}

LoginView.defaultProps = {
  captcha: {
    isReady: false,
  },
  login: null,
  isLoading: false,
  loginError: {
    valid: true,
    errorMessage: '',
  },
};

LoginView.propTypes = {
  /** Function to generate a new captcha */
  generateCaptcha: PropTypes.func.isRequired,
  /** Function to check login credentials */
  checkCredentials: PropTypes.func.isRequired,
  /** Function to create the identities object */
  createIdentities: PropTypes.func.isRequired,
  /** Function to clear input error */
  clearInputError: PropTypes.func.isRequired,
  /** Function to set input error */
  setInputError: PropTypes.func.isRequired,
  /** String user login */
  login: PropTypes.string,
  /** Object login errors */
  loginError: PropTypes.shape({
    valid: PropTypes.bool,
    errorMessage: PropTypes.string,
  }),
  /** Object captcha */
  captcha: PropTypes.shape({
    indications: PropTypes.array,
    images: PropTypes.array,
    status: PropTypes.shape({
      valid: PropTypes.bool,
      errorMessage: PropTypes.string,
    }),
    selectedImages: PropTypes.array,
    isReady: PropTypes.bool,
  }),
  /** Boolean indicate a pending request */
  isLoading: PropTypes.bool,
};

export default LoginView;
